<div class="inline-flex w-full pb-4">
  @if (svgIcon) {
    <mat-icon [svgIcon]="svgIcon" class="icon-size-10 pr-5" />
  }
  <div>
    @if (label) {
      <div class="detail-label" [innerHTML]="label"></div>
    }
    @if (link && !isValueEmpty) {
      @if (link && !isValueEmpty) {
        <div class="detail-value">
          <a class="entityLink" [routerLink]="link" [innerHTML]="value"></a>
        </div>
      }
    } @else if (externalLink && !isValueEmpty) {
      @if (externalLink && !isValueEmpty) {
        <div class="detail-value">
          <a class="entityLink" [href]="externalLink" [innerHTML]="value"></a>
        </div>
      }
    } @else if (clickable && !isValueEmpty) {
      <div class="detail-value">
        <a class="entityLink" [routerLink]="null" (click)="linkClicked()" [innerHTML]="value"></a>
      </div>
    } @else {
      <div class="detail-value" [innerHTML]="value"></div>
    }
  </div>
</div>
